import Heading from '@/common/shared/heading'
import { Separator } from '@/common/ui/separator'
import EventLogTable from '../EventLogTable'
import {
	GetMemberEventLogRequest,
	GetMemberEventLogTableData,
} from '@/modules/manage-member/type'
import { DateRangePicker } from '@/common/components/DateRangePicker'
interface EventLogListingProps {
	data: GetMemberEventLogTableData[]
	total: number
	isLoading?: boolean
	filters: GetMemberEventLogRequest
}

export default function EventLogListing({
	data,
	total,
	isLoading,
	filters,
}: EventLogListingProps) {
	return (
		<div className="space-y-4">
			<div className="flex items-start justify-between">
				<Heading
					title={`ประวัติการทำรายการ`}
					description="ประวัติการทำรายการ"
				/>
				<DateRangePicker />
			</div>
			<Separator />
			<EventLogTable
				data={data}
				total={total}
				isLoading={isLoading}
				filters={filters}
			/>
		</div>
	)
}
